import {
  useRequestStore,
  useRequestPersistedStore,
  useRequest,
} from "entities/Request";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import api, { baseApiService } from "shared/api";
import { Button, Form } from "shared/ui";
import { withToast } from "shared/utils";
import "./ChangeTravelAcceptanceStatus.styles.css";
import { useTranslation } from "react-i18next";

function ChangeTravelAcceptanceStatus({
  control,
  handleSubmit,
  errors,
  loadingTravelAcceptorDependencies,
  cwtStatusesOptions,
  administrativeUsersOptions,
  form,
}) {
  const { t } = useTranslation("TravelAcceptor");
  const request = useRequestStore((state) => state.request);
  const viewRequestAs = useRequestPersistedStore(
    (state) => state.viewRequestAs
  );
  const { mutate } = useRequest(request?.number, viewRequestAs.role);

  const [isLoading, setIsLoading] = useState(false);
  const onSubmit = () => {
    handleSubmit(async ({ person_responsible, status }) => {
      setIsLoading(true);
      await withToast(
        () =>
          api.post(baseApiService.ENDPOINTS.cwt.update, {
            status,
            administration_user_id: person_responsible,
            application_id: request?.id,
          }),
        {
          onSuccess: t("toasts.acceptance_status_changed"),
        }
      ).finally(() => {
        mutate().then(() => {
          setIsLoading(false);
        });
      });
    })();
  };

  const {
    formState: { isDirty },
  } = form;

  return (
    <Row className="pb-5">
      <Col md={5}>
        <Form.Select
          name="person_responsible"
          label={t("labels.person_responsible")}
          control={control}
          error={errors?.person_responsible}
          isLoading={loadingTravelAcceptorDependencies}
          options={administrativeUsersOptions}
        />
      </Col>
      <Col md={5}>
        <Form.Select
          isSearchable={false}
          name="status"
          label={t("labels.status")}
          control={control}
          isLoading={loadingTravelAcceptorDependencies}
          error={errors?.status}
          options={cwtStatusesOptions}
        />
      </Col>

      <Col md={2} className="travel-acceptance__save">
        <Button
          onClick={onSubmit}
          isLoading={isLoading}
          popoverHandlers={{
            className: "travel-acceptance__save-popover",
          }}
          className="travel-acceptance__save-button"
          disabled={isLoading || !isDirty}
        >
          {t("buttons.save")}
        </Button>
      </Col>
    </Row>
  );
}

export default ChangeTravelAcceptanceStatus;
